var dd = require('react-dd');
var esUtils = require('../utils/esUtils');
var HoverMixin = require('../utils/HoverMixin');

module.exports = dd.createClass({
	mixins: [HoverMixin],
	not_relative_to_parent_bounding_rect: true,
	__onClick: esUtils.wrapPreventDefault(function(){}),
	render: function(){
		return dd.a({
				className: 'HelpTooltip',
				href: '#',
				style: {position: 'relative'},
				onMouseEnter: this.hoverable_onMouseEnter,
				onMouseLeave: this.hoverable_onMouseLeave,
				onClick: this.__onClick
			},
			dd.i({className: 'fa fa-question-circle'}),
			dd.div({className: 'popover top', ref: 'hoverable', style: {
					display: this.state.hover ? 'block' : 'none',//hide show so that we can keep access to the dom node's width height in componentDidUpdate
					width: this.props.content ? Math.max(70, this.props.content.length * 14) + 'px' : 'auto',//aprox the width for the content, note that .popover class sets a max-width, so no worries
					top: this.state.hoverable_top + 'px',
					left: this.state.hoverable_left + 'px',

					//normalizing styles (so parent font styling doesn't mess with this)
					fontSize: '14px',
					color: 'black',
					textAlign: 'left',
					fontWeight: 'normal'
				}},
				dd.div({className: 'arrow'}),
				this.props.title ? dd.h3({className: 'popover-title'}, this.props.title) : '',
				this.props.content ? dd.div({className: 'popover-content'}, this.props.content) : ''
			)
		);
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/HelpTooltip.js
// module id = 114
// module chunks = 0 1 2 3 4